import { render, staticRenderFns } from "./EditarRegimenJubilatorio.vue?vue&type=template&id=b56419cc&"
import script from "./EditarRegimenJubilatorio.vue?vue&type=script&lang=js&"
export * from "./EditarRegimenJubilatorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports